export default __webpack_public_path__ + "img/apple-icon-152x152.png";